<aur-mat-table [tableData]="tableData"
               [tableConfig]="tableConfig">
  <ng-template ngxAurExtraHeaderTopDef let-key="key" let-index="index">
    <div (click)="alert('Click on ' + key)" class="extra-top-header">
      Extra top header key: '{{ key }}' index={{index}}
    </div>
  </ng-template>
  <ng-template ngxAurExtraHeaderBottomDef let-key="key" let-index="index">
    <div (click)="alert('Click on ' + key)" class="extra-bottom-header">
      Extra bottom header key: '{{ key }}' index={{index}}
    </div>
  </ng-template>
</aur-mat-table>
